const Builder = require('./BuilderBase');
const DatePicker = require('./formElements/DatePicker');
const DropDown = require('./formElements/DropDown');
const EditableList = require('./formElements/EditableList');
const FormButton = require('./FormButton/FormButton');
const InvisibleElement = require('./InvisibleElement');
const ShortText = require('./formElements/ShortText');
const Toggle = require('./formElements/Toggle');
const WorkflowActionList = require('./WorkflowActionList');
const WorkflowCriteriaPane = require('./WorkflowCriteriaPane');
const MultiPickerSensorGrid = require('./formElements/MultiPickerSensorGrid');

module.exports = class SubForm extends Builder {
    constructor(title, properties) {
        super('form_SubForm', title, properties);
    }

    datePicker(title, properties) {
        const datePicker = new DatePicker(title, properties);
        this.addChildBlock(datePicker);
        return datePicker;
    }

    toggle(title, properties) {
        let toggle = new Toggle(title, properties);
        this.addChildBlock(toggle);
        return toggle;
    }

    shortText(title, properties) {
        let shortText = new ShortText(title, properties);
        this.addChildBlock(shortText);
        return shortText;
    }

    dropDown(title, properties) {
        let dropDown = new DropDown(title, properties);
        this.addChildBlock(dropDown);
        return dropDown;
    }

    formButton(title, properties) {
        let button = new FormButton(title, properties);
        this.addChildBlock(button, 'formButtons');
        return button;
    }

    editableList(title, properties) {
        let editableList = new EditableList(title, properties);
        this.addChildBlock(editableList);
        return editableList;
    }

    workflowCriteriaPane() {
        let criteriaPane = new WorkflowCriteriaPane();
        this.addChildBlock(criteriaPane);
        return criteriaPane;
    }

    workflowActionList(title) {
        let actionList = new WorkflowActionList(title);
        this.addChildBlock(actionList);
        return actionList;
    }

    invisibleElement(title, properties) {
        let element = new InvisibleElement(title, properties);
        this.addChildBlock(element);
        return element;
    }

    image(title, properties) {
        const image = new Image(title, properties);
        this.addChildBlock(image);
        return image;
    }

    layout(options) {
        // requiring this inline avoids problems with looping dependencies.
        let layout = new (require('./Layout'))('testLayout');
        this.addChildBlock(layout, undefined, options);
        return layout;
    }

    MultiPickerSensorGrid(title, properties) {
        const picker = new MultiPickerSensorGrid(title, properties);
        this.addChildBlock(picker);
        return picker;
    }
};
